<template>
  <div class="whole-page no-sidebar">
    <div class="page-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoSidebar'
}
</script>
